import { SagaReturnType, call, put, takeLatest } from 'redux-saga/effects';
import therapistService from '../../../services/apiServices/therapist-scheduling/therapistService';
import { TherapistAction } from '../../actions/constant';

const {
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_REQUEST,
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_SUCCESS,
  GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_FAILURE,
} = TherapistAction;

function* getClockInOutButtonVisibility(): SagaReturnType<any> {
  try {
    const facilityUuid = localStorage.getItem('facilityId') || '';

    // Without a facility we cannot resolve the flag -> hide (treat as false).
    if (!facilityUuid) {
      yield put({ type: GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_FAILURE });
      return;
    }

    const response = yield call(therapistService.getClockInOutButtonVisibility, facilityUuid);

    if (response?.status === 200) {
      yield put({
        type: GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_SUCCESS,
        // Standard response envelope: { data: boolean }.
        payload: response?.data?.data,
      });
    } else {
      // Non-200 (including 404) -> hide.
      throw response?.data;
    }
  } catch (error) {
    // Any error/404 -> hide the button and warnings (APIT-587).
    yield put({ type: GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_FAILURE });
  }
}

function* clockInOutButtonVisibilitySaga() {
  yield takeLatest(GET_CLOCK_IN_OUT_BUTTON_VISIBILITY_REQUEST, getClockInOutButtonVisibility);
}

export default clockInOutButtonVisibilitySaga;
